import { Indicator, Paper, Stack, Text } from "@mantine/core";
import { useEventListQuery, useEventQueries } from "@vantage/core";
import { EventCard, type EventCardProps } from "../../components/content/event/card/EventCard";
import { createFileRoute } from "@tanstack/react-router";
import { ResolvedEventContext } from "@vantage/core";
import { CalendarLayout } from "../../components/calendar/CalendarLayout";

export const Route = createFileRoute("/_layout/calendar")({
	component: CalendarPage,
	staticData: {
		spaceless: true,
	},
})

export default function CalendarPage() {
	const h = "calc(100svh - var(--app-shell-header-height, 0px) - 2 * var(--app-shell-padding) - var(--safe-area-inset-top) - var(--safe-area-inset-bottom))";

	return (
		<Stack
			h={h}
			mah={h}
			align="center"
			justify="center"
		>
			<CalendarLayout />
		</Stack>
	)
};

export const DayButton = ({
	day,
}: {
	day: `${number}-${number}-${number}`;
}) => {
	const { events } = useEventListQuery({
		beforeTimestamp: Temporal.PlainDate.from(day).add({ days: 1 }).toZonedDateTime({ timeZone: "UTC" }).toInstant().epochMilliseconds,
		afterTimestamp: Temporal.PlainDate.from(day).toZonedDateTime({ timeZone: "UTC" }).toInstant().epochMilliseconds,
	});

	return (
		<Indicator
			label={events.length ?? 0}
			size={16}
			position="bottom-center"
			offset={{ x: 0, y: -4 }}
			disabled={events.length === 0}
			showZero={false}
			color="var(--mantine-color-blue-light)"
		>
			<Paper
				component="div"
				bg="transparent"
			>
				<Text>{day.slice(8)}</Text>
			</Paper>
		</Indicator>
	);
};

export const DayCard = ({
	day,
	variant,
}: {
	day: `${number}-${number}-${number}`;
	variant?: EventCardProps["variant"];
}) => {
	const lowTimestamp = Temporal.PlainDate.from(day).toZonedDateTime({ timeZone: "UTC" }).toInstant().epochMilliseconds;
	const highTimestamp = Temporal.PlainDate.from(day).add({ days: 1 }).toZonedDateTime({ timeZone: "UTC" }).toInstant().epochMilliseconds - 1;
	const { events } = useEventListQuery({
		beforeTimestamp: highTimestamp,
		afterTimestamp: lowTimestamp,
	});

	return (
		<Stack gap={0}>
			{events.map((query, index) => (
				<ResolvedEventContext key={index} value={query.data ?? null}
				>
					<EventCard
						variant={variant}
						loading={query.isFetching}
					/>
				</ResolvedEventContext>
			))}
		</Stack>
	);
};
